/**
 * @flow
 * @relayHash d2cb1c30b47bca2e42bbd65ff6f56d11
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AddUpdateCustomerModal_customer$ref = any;
type AddUpdateOrderModal_customer$ref = any;
type CustomerSidePanel_customer$ref = any;
export type UpdateCustomerAddressInput = {|
  id: string,
  label?: ?string,
  addressLine1?: ?string,
  addressLine2?: ?string,
  addressLine3?: ?string,
  addressCity?: ?string,
  addressState?: ?string,
  addressZip?: ?string,
  addressCountry?: ?string,
  isDefault?: ?boolean,
|};
export type UpdateCustomerAddressMutationVariables = {|
  input: UpdateCustomerAddressInput
|};
export type UpdateCustomerAddressMutationResponse = {|
  +updateCustomerAddress: {|
    +customer: {|
      +id: string,
      +$fragmentRefs: CustomerSidePanel_customer$ref & AddUpdateCustomerModal_customer$ref & AddUpdateOrderModal_customer$ref,
    |},
    +customerAddress: {|
      +id: string,
      +label: string,
      +addressLine1: ?string,
      +addressLine2: ?string,
      +addressLine3: ?string,
      +addressCity: ?string,
      +addressState: ?string,
      +addressZip: ?string,
      +addressCountry: ?string,
      +isDefault: boolean,
    |},
  |}
|};
export type UpdateCustomerAddressMutation = {|
  variables: UpdateCustomerAddressMutationVariables,
  response: UpdateCustomerAddressMutationResponse,
|};
*/


/*
mutation UpdateCustomerAddressMutation(
  $input: UpdateCustomerAddressInput!
) {
  updateCustomerAddress(input: $input) {
    customer {
      id
      ...CustomerSidePanel_customer
      ...AddUpdateCustomerModal_customer
      ...AddUpdateOrderModal_customer
    }
    customerAddress {
      id
      label
      addressLine1
      addressLine2
      addressLine3
      addressCity
      addressState
      addressZip
      addressCountry
      isDefault
    }
  }
}

fragment CustomerSidePanel_customer on Customer {
  id
  customerNumber
  secondaryContactName
  addresses {
    id
    label
    addressLine1
    addressLine2
    addressLine3
    addressCity
    addressState
    addressZip
    addressCountry
    isDefault
  }
  billingAddressLine1
  billingAddressLine2
  billingAddressLine3
  billingAddressCity
  billingAddressState
  billingAddressZip
  email
  phone
  phone2
  fax
  notes
}

fragment AddUpdateCustomerModal_customer on Customer {
  id
  name
  primaryContactName
  secondaryContactName
  addresses {
    id
    label
    addressLine1
    addressLine2
    addressLine3
    addressCity
    addressState
    addressZip
    addressCountry
    isDefault
  }
  billingAddressLine1
  billingAddressLine2
  billingAddressLine3
  billingAddressCity
  billingAddressState
  billingAddressZip
  email
  phone
  phone2
  fax
  notes
  salesUser {
    id
    firstName
    lastName
  }
}

fragment AddUpdateOrderModal_customer on Customer {
  id
  shippingAddressLine1
  shippingAddressLine2
  shippingAddressLine3
  shippingAddressCity
  shippingAddressState
  shippingAddressZip
  addresses {
    id
    label
    addressLine1
    addressLine2
    addressLine3
    addressCity
    addressState
    addressZip
    isDefault
  }
  defaultAddress {
    id
    label
    addressLine1
    addressLine2
    addressLine3
    addressCity
    addressState
    addressZip
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCustomerAddressInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "addressLine1",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "addressLine2",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "addressLine3",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "addressCity",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "addressState",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "addressZip",
  "args": null,
  "storageKey": null
},
v10 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "addressCountry",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isDefault",
    "args": null,
    "storageKey": null
  }
],
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "customerAddress",
  "storageKey": null,
  "args": null,
  "concreteType": "CustomerAddress",
  "plural": false,
  "selections": (v10/*: any*/)
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateCustomerAddressMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCustomerAddress",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCustomerAddressPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "customer",
            "storageKey": null,
            "args": null,
            "concreteType": "Customer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "CustomerSidePanel_customer",
                "args": null
              },
              {
                "kind": "FragmentSpread",
                "name": "AddUpdateCustomerModal_customer",
                "args": null
              },
              {
                "kind": "FragmentSpread",
                "name": "AddUpdateOrderModal_customer",
                "args": null
              }
            ]
          },
          (v11/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateCustomerAddressMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCustomerAddress",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCustomerAddressPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "customer",
            "storageKey": null,
            "args": null,
            "concreteType": "Customer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customerNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "secondaryContactName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "addresses",
                "storageKey": null,
                "args": null,
                "concreteType": "CustomerAddress",
                "plural": true,
                "selections": (v10/*: any*/)
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "billingAddressLine1",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "billingAddressLine2",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "billingAddressLine3",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "billingAddressCity",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "billingAddressState",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "billingAddressZip",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "phone",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "phone2",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fax",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "primaryContactName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "salesUser",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressLine1",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressLine2",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressLine3",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressCity",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressState",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shippingAddressZip",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "defaultAddress",
                "storageKey": null,
                "args": null,
                "concreteType": "CustomerAddress",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ]
              }
            ]
          },
          (v11/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateCustomerAddressMutation",
    "id": null,
    "text": "mutation UpdateCustomerAddressMutation(\n  $input: UpdateCustomerAddressInput!\n) {\n  updateCustomerAddress(input: $input) {\n    customer {\n      id\n      ...CustomerSidePanel_customer\n      ...AddUpdateCustomerModal_customer\n      ...AddUpdateOrderModal_customer\n    }\n    customerAddress {\n      id\n      label\n      addressLine1\n      addressLine2\n      addressLine3\n      addressCity\n      addressState\n      addressZip\n      addressCountry\n      isDefault\n    }\n  }\n}\n\nfragment CustomerSidePanel_customer on Customer {\n  id\n  customerNumber\n  secondaryContactName\n  addresses {\n    id\n    label\n    addressLine1\n    addressLine2\n    addressLine3\n    addressCity\n    addressState\n    addressZip\n    addressCountry\n    isDefault\n  }\n  billingAddressLine1\n  billingAddressLine2\n  billingAddressLine3\n  billingAddressCity\n  billingAddressState\n  billingAddressZip\n  email\n  phone\n  phone2\n  fax\n  notes\n}\n\nfragment AddUpdateCustomerModal_customer on Customer {\n  id\n  name\n  primaryContactName\n  secondaryContactName\n  addresses {\n    id\n    label\n    addressLine1\n    addressLine2\n    addressLine3\n    addressCity\n    addressState\n    addressZip\n    addressCountry\n    isDefault\n  }\n  billingAddressLine1\n  billingAddressLine2\n  billingAddressLine3\n  billingAddressCity\n  billingAddressState\n  billingAddressZip\n  email\n  phone\n  phone2\n  fax\n  notes\n  salesUser {\n    id\n    firstName\n    lastName\n  }\n}\n\nfragment AddUpdateOrderModal_customer on Customer {\n  id\n  shippingAddressLine1\n  shippingAddressLine2\n  shippingAddressLine3\n  shippingAddressCity\n  shippingAddressState\n  shippingAddressZip\n  addresses {\n    id\n    label\n    addressLine1\n    addressLine2\n    addressLine3\n    addressCity\n    addressState\n    addressZip\n    isDefault\n  }\n  defaultAddress {\n    id\n    label\n    addressLine1\n    addressLine2\n    addressLine3\n    addressCity\n    addressState\n    addressZip\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '590720a00ff960678a2257330657d4dd';
module.exports = node;
